import React, { Fragment } from 'react';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Collapse } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';

const useStyle = makeStyles({
	listItem: {
		paddingLeft: '14px',
		paddingRight: '14px',
		'& p': {
			fontSize: '1rem'
		},
		'& span': {
			color: 'rgba(0, 0, 0, 0.87)',
			fontSize: '1rem'
		}
	},
	menuItemLink: {
		color: '#283593'
	},
	listItemIcon: {
		paddingRight: '1em',
		marginRight: 0
	},
	listItemText: {
		paddingLeft: 0,
		fontSize: '1rem',
		'&:first-child': {
			paddingLeft: 0
		}
	},
	sidebarIsOpen: {
		paddingLeft: 10,
		transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
	},
	sidebarIsClosed: {
		paddingLeft: 0,
		transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
	}
});

const renderIcon = (icon, classes) => {
	return icon ? <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon> : null;
};

const SubMenu = ({ handleToggle, sidebarIsOpen, isOpen, name, icon, children }) => {
	const translate = useTranslate();
	const classes = useStyle();
	return (
		<Fragment>
			<ListItem dense button onClick={handleToggle} className={classes.listItem}>
				{renderIcon(icon, classes)}
				<ListItemText
					inset
					primary={isOpen ? translate(name) : ''}
					secondary={isOpen ? '' : translate(name)}
					className={classes.listItemText}
				/>
				{isOpen ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={isOpen} timeout="auto" unmountOnExit>
				<List
					dense
					component="div"
					disablePadding
					className={sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed}
				>
					{children}
				</List>
				<Divider />
			</Collapse>
		</Fragment>
	);
};

export default SubMenu;
